import { TabWrap, SectionType } from 'sections/TabWrap';

import { Table } from 'components/Table';

import { useColumns } from './columns.data';

export function RelatedProducts(): React.ReactElement {
  const columns = useColumns();

  const sections: SectionType[] = [
    {
      id: 1,
      content: <div>Search Bar</div>,
    },
    {
      id: 2,
      content: <Table motive="m2" columns={columns} data={[]} />,
    },
  ];

  return <TabWrap sections={sections} />;
}
